export const ellipsisHeaderOptions = [{ label: 'Add', value: 'Add', callback: 'onClickPrint' }];
export const ellipsisRowOptions = [
  { label: 'Edit', value: 'Edit', callback: 'onRowEdit' },
  { label: 'Delete', value: 'Delete', callback: 'onRowDelete' }
];
